import React from 'react';

import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';


const CellsList = ({cells, selectedCells, onCellsSelectionChange}) => {


  const handleChangeCells = (event) => {
      let cellName = event.target.name;
      console.log(`Setting ${cellName} as selected`);
      onCellsSelectionChange(cellName, event.target.checked);
  };

  return (
    <>
    <InputLabel id="select-cells-label">Cells</InputLabel>
    <Select
      labelId="selectCells"
      id="select-cells"
      onChange={handleChangeCells}
    >
      {cells.map(cell =>
        <FormControlLabel
          control={<Checkbox 
                      checked={selectedCells.includes(cell.device_name)} 
                      onChange={handleChangeCells} 
                      name={cell.device_name}
                      value={cell.id} 
                      color="primary"
                    />}
          label={cell.device_name}
          key={'check_' + cell.id}
      />
      )}
    </Select>
    </>
  );
};

export default CellsList;